import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Home, LayoutDashboard } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function NotFound() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-950 px-4">
      <div className="text-center max-w-md">
        <h1 className="text-8xl font-extrabold bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
          404
        </h1>
        <h2 className="mt-4 text-2xl font-bold text-gray-900 dark:text-gray-100">
          {t('errors.pageNotFound', 'Page not found')}
        </h2>
        <p className="mt-2 text-gray-500 dark:text-gray-400">
          {t(
            'errors.pageNotFoundDescription',
            "The page you're looking for doesn't exist or has been moved."
          )}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild variant="gradient" size="lg">
            <Link to="/app/dashboard" className="flex items-center gap-2">
              <LayoutDashboard className="h-4 w-4" />
              {t('errors.goToDashboard', 'Go to Dashboard')}
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="/" className="flex items-center gap-2">
              <Home className="h-4 w-4" />
              {t('errors.goHome', 'Go Home')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
